import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';

export const DashboardViewModule = new Module({
  id: 'dashboard-main',
  name: 'Dashboard',
  path: 'dashboard',
  Component: ComponentLoader(lazy(() => import('src/content/dashboards/Erp')))
});

const DashboardModules = [DashboardViewModule];

export default DashboardModules;
